import React, { useState } from 'react'
import TrainingDays from '../components/tranings/trainingdays/TrainingDays'
import SubTab from '../components/SubTab'
import Guides from '../components/tranings/guides/Guides'
import Title_certificate from '../components/tranings/title_certificate/Title_certificate'
import Case from '../components/tranings/case/Case'
import Membership from '../components/tranings/membership/Membership'
import KalahMembership from '../components/tranings/kalah/KalahMembership'
import Benefits from '../components/tranings/benefits/Benefits'

const Tranings = ({setHide}) => {
    const [active, setActive] = useState("ימי כשירות")
    return (
        <div className='bg-[#f3f3f3] p-4 ' >
            {/* <ul className='flex justify-end m-0 list-none'> */}

            <ul className='flex flex-row-reverse  m-0 list-none  '   >
                <SubTab active={active == "ימי כשירות"} onClick={() => { setActive("ימי כשירות") }}>ימי כשירות </SubTab>
                <SubTab active={active == "הטבות"} onClick={() => { setActive("הטבות") }}>הטבות </SubTab>
                <SubTab active={active == "מארזים"} onClick={() => { setActive("מארזים") }}>מארזים </SubTab>
                <SubTab active={active == "מדריכים"} onClick={() => { setActive("מדריכים") }}>מדריכים</SubTab>
                <SubTab active={active == "כותרת לתעודה"} onClick={() => { setActive("כותרת לתעודה") }}>כותרת לתעודה </SubTab>
                <SubTab active={active == "דמי חבר"} onClick={() => { setActive("דמי חבר") }}>דמי חבר </SubTab>
                <SubTab active={active == 'קל"ה'} onClick={() => { setActive('קל"ה') }}>קל"ה</SubTab>
                {/* <li key={1} className={active == 1 ? 'p-2 m-1 rounded-t-md bg-slate-500' : 'p-2 m-1 rounded-t-md hover:bg-slate-500'} onClick={() => { setActive(1) }}>ימי כשירות</li>
                <li key={2} className={active == 2 ? 'p-2 m-1 rounded-t-md bg-slate-500' : 'p-2 m-1 rounded-t-md hover:bg-slate-500'} onClick={() => { setActive(2) }}>מדריכים</li>
                <li key={3} className={active == 3 ? 'p-2 m-1 rounded-t-md bg-slate-500' : 'p-2 m-1 rounded-t-md hover:bg-slate-500'} onClick={() => { setActive(3) }}>כותרת לתעודה</li> */}
            </ul>
            <div className='bg-white w-full'>
               {active=="ימי כשירות"&&<TrainingDays setHide={setHide} />}
               {active=="הטבות"&&<Benefits/>}
               {active=="מארזים"&&<Case/>}
               {active=="מדריכים"&&<Guides setHide={setHide}/>}
               {active=="כותרת לתעודה"&&<Title_certificate setHide={setHide}/>}
               {active=="דמי חבר"&&<Membership setHide={setHide}/>}
               {active=='קל"ה'&&<KalahMembership setHide={setHide}/>}
            </div>

        </div>
    )
}

export default Tranings